@if (loader.isVisible$ | async) {
  <div class="loading-overlay" [class.is-leaving]="loader.isLeaving$ | async">
    <app-card-loader></app-card-loader>
  </div>
}
